import axios from '@axios'

const PREFIX = '/webhooks'

export default {
  getConfiguracaoWebhook() {
    return axios.get(`${PREFIX}`)
  },

  addUpdateConfiguracaoApi(value) {
    return axios.post(`${PREFIX}`, value)
  },
  addAssinante(value) {
    return axios.post(`${PREFIX}/assinante`, value)
  },
  deleteAssinantes(ids) {
    return axios.delete(`${PREFIX}/assinante`, { data: ids })
  },
}
